"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const modal_js_1 = __importDefault(require("bootstrap/js/dist/modal.js"));
exports.default = {
    mounted() {
        let parentElement = this.el;
        var modal = new modal_js_1.default(parentElement);
        this.handleEvent("wants_in_sent", () => {
            let modalWindow = window;
            if (modalWindow.modal) {
                modalWindow.modal.hide();
            }
            modal.show();
            window.modal = modal;
            setTimeout(() => {
                window.modal = undefined;
                modal.hide();
            }, 7000);
        });
    }
};
